class LeAnniversaryCommunity extends LeCommunityShare {
  constructor() {
    super();

    this.mediaAggt = {
      glow: [
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-1.png?v=1753952618', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/88fece7070934aac89931c94667ae364.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-2.png?v=1753952616', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/e457f7f959b44a55a6614287213bc696.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-7.png?v=1753952619', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/f2b5ce64578746f1b9a27ca2d0a44e01.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-3.png?v=1753952618', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/b79879fc70fb41baaa9771ceca8ab9a3.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-4.png?v=1753952618', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/961a0eb4f19f4b578f096dd92373b03a.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-5.png?v=1753952616', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/13687209b4204ca895588508e111b554.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-6.png?v=1753952618', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/1d4db0ff64a0471dab9adcb0ec3a1e90.mp4' },
        { imgUrl: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/lepro-back-to-school__say-8.png?v=1753952618', videoUrl: 'https://cdn.shopify.com/videos/c/o/v/de859cf0139d481cb81ef925dba6147e.mp4' }
      ]
    }

    this.init()
  }
}
customElements.define('le-anniversary-community', LeAnniversaryCommunity)

class LeProductSelect extends HTMLElement {
  constructor() {
    super();

    this.bindEvent()
    this.init()
  }

  init() {
  }

  bindEvent() {
    const checkoutNodes = this.querySelectorAll('.checkout-input')
    checkoutNodes.forEach((item) => {
      item.addEventListener('click', this.handlerCheckout.bind(this))
    })
  }

  // 选择多个商品
  handlerCheckout(e) {
    e.preventDefault()
    const current = e.currentTarget

    let productItems = []
    let productCoupons = []

    const addCartBtn = this.querySelector('le-add-cart-btn-anniversary')
    if (addCartBtn) {
      const dataProducts = addCartBtn.getAttribute('data-products')
      const dataCoupons = addCartBtn.getAttribute('data-coupons')
      if (dataProducts) {
        productItems = JSON.parse(dataProducts)
      }
      if (dataCoupons) {
        productCoupons = JSON.parse(dataCoupons)
      }
    }

    // 选择多个商品，设置数量和coupon
    const hasClass = current.classList.contains('active')
    if (hasClass) {
      current.classList.remove('active')
      productItems = productItems.filter((item) => item.id != current.dataset.id)
      productCoupons = productCoupons.filter((item) => item.id != current.dataset.id)
    } else {
      current.classList.add('active')
      productItems.push({
        id: current.dataset.id,
        quantity: 1,
      })

      const coupon = current.dataset.coupon
      if (coupon) {
        productCoupons.push({
          id: current.dataset.id,
          coupon: coupon
        })
      }
    }

    addCartBtn.setAttribute('data-products', JSON.stringify(productItems))
    addCartBtn.setAttribute('data-coupons', JSON.stringify(productCoupons))
  }
}
customElements.define('le-product-select', LeProductSelect)

class LeHolidayMain extends HTMLElement {
  constructor() {
    super();

    this.endAt = '2025-09-21T23:59:59Z'
    this.timerCode = null

    this.timerCodeProduct = null

    this.elements = this.getElements()

    this.init()
  }

  init() {
    this.renderTime()
    this.setCountdown()

    this.productCountDownFn()
    this.setProductCountTme()

    this.bindEvent()
  }

  getElements() {
    return {
      countDownEl: this.querySelectorAll('[data-count-down]'),
      productCountDownEl: this.querySelectorAll('[data-deal-time]'),
      termsRulesBtn: this.querySelector('[data-terms-rules-btn]'),
      termsRulesDialog: this.querySelector('[data-terms-rules]'),
    }
  }

  // 规则按钮
  bindEvent() {
    this.elements.termsRulesBtn.addEventListener('click', this.handlerTermsRules.bind(this))
  }

  // 规则按钮
  handlerTermsRules() {
    this.elements.termsRulesDialog.style.display = 'block'
  }

  // 设置倒计时
  setCountdown() {
    this.timerCode = setInterval(() => {
      this.renderTime()
    }, 1000)
  }

  renderTime() {
    const timeStamp = this.getTimeStamp()
    if (timeStamp && timeStamp >= 0) {
      const formatDate = window.ShopifyConstant.combinationNode(timeStamp)
      this.setDom(formatDate)
      return
    }

    clearInterval(this.timerCode)
    this.timerCode = null
  }

  // 获取截止日期时间戳
  getTimeStamp() {
    const nowDate = new Date()
    const currentTime_us = window.ShopifyConstant.formatterTime(nowDate)
    const currentTime = new Date(currentTime_us).getTime()

    const endTime = new Date(this.endAt.replace('Z', '')).getTime()

    return endTime - currentTime
  }

  // 设置 dom
  setDom(date) {
    const node = `<div class="count-down-number-item">
        <div class="number">${date.dd}</div>
        <div class="unit">Days</div>
      </div>
      <div class="count-down-number-item">
        <div class="number">${date.hh}</div>
        <div class="unit">Hours</div>
      </div>
      <div class="count-down-number-item">
        <div class="number">${date.mm}</div>
        <div class="unit">Mins</div>
      </div>
      <div class="count-down-number-item">
        <div class="number">${date.ss}</div>
        <div class="unit">Secs</div>
      </div>`

    this.elements.countDownEl.forEach(el => {
      el.innerHTML = node
    })
  }

  // 设置 产品倒计时
  setProductCountTme() {
    clearInterval(this.timerCodeProduct)
    this.timerCodeProduct = setInterval(() => {
      this.productCountDownFn()
    }, 1000)
  }
  // 倒计时的方法
  productCountDownFn() {
    const nowDate = new Date()
    const currentTime_us = window.ShopifyConstant.formatterTime(nowDate)
    const currentTime = new Date(currentTime_us).getTime()

    this.elements.productCountDownEl.forEach(el => {
      const endTimeAtt = el.getAttribute('data-end-time')
      if (endTimeAtt) {
        const endTime = new Date(endTimeAtt.replace('Z', '')).getTime()
        const time = endTime - currentTime

        const poorTimeStamp = window.ShopifyConstant.lessThanDay_7(endTimeAtt)
        if (poorTimeStamp) {
          this.renderPorductNode(el, time) // 这里还是用 time 实现保持当前倒计时一致

          el.style.display = 'block'
          return
        }
      }
      el.style.display = 'none'
    })
  }
  // 渲染产品倒计时html
  renderPorductNode(el, timeStamp) {
    if (timeStamp && timeStamp >= 0) {
      const formatDate = window.ShopifyConstant.combinationNode(timeStamp)
      const text = `Deal Ends In ${formatDate.dd}D ${formatDate.hh}H ${formatDate.mm}M ${formatDate.ss}S`
      el.innerHTML = text
    }

  }
}
customElements.define('le-holiday-main', LeHolidayMain)

// tab切换
class LeTabAnniversary extends LeTabComponent {
  init() {
    this.customBindEvent()
  }

  customBindEvent() {
    const dataMoreLink = this.getElements().dataMoreLink
    if (dataMoreLink) {
      dataMoreLink.addEventListener('click', this.handlerMoreLink.bind(this))
    }
  }

  handlerMoreLink() {
    const dataExpand = this.getAttribute('data-expand')
    if (dataExpand) {
      this.removeAttribute('data-expand')
    } else {
      this.setAttribute('data-expand', 'true')
    }
  }

  getElements() {
    return {
      dataMoreLink: this.querySelector('[data-more-link]')
    }
  }

  // click 回调函数，给其它继承的组件使用
  // 子类可以重写这个方法
  _handleTabClickCallback(index) {
    const products = window.__anniversaryContext.tabItems[index]
    if (products) {
      this.renderItem(products)
    }
  }

  // 渲染商品列表
  renderItem(products) {
    let contentNode = ''

    const limit = parseFloat(this.getAttribute('data-more-num')) || 12

    let is_more = true

    products.forEach((product, index) => {
      let variantProduct = product.variants[0]

      for (let i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) {
          variantProduct = product.variants[i]
          break
        }
      }

      const metafields = variantProduct.metafields?.custom

      const variantsDiscounts = metafields?.variants_discounts_and_marketing || null

      const priceNode = window.ShopifyConstant.renderPrice(variantProduct, metafields)
      const offPriceNode = window.ShopifyConstant.renderOffPrice(metafields, variantProduct)
      const dealTimeNode = this.renderDealTime(metafields)

      if (index >= limit && is_more) {
        contentNode += '<div class="le-product-more-box flex flex-wrap">'
        is_more = false
      }

      contentNode += `<div class="deals-item lepro-anniversary-product relative flex flex-direction justify-between">
        ${offPriceNode}
        <div>
          <div class="product-img-block cursor-pointer">
            <div class="product-img relative">
              <img src="${product.media[0]?.src}" alt="${product.title}" class="img">
            </div>
          </div>
      
          <a class="product-name line-clamp-2 align-center" href="/products/${product.handle}">${product.title}</a>
        </div>

        <div class="product-content">
          ${dealTimeNode}

          <div class="price-block align-center">
            ${priceNode}
          </div>
          <le-add-cart-btn-anniversary>
            <button type="button" data-id="${variantProduct.id}" data-coupon="${window.isB2BCustomer ? '' : (variantsDiscounts?.product_detail_max_discount?.code || '')}" class="add-to-btn lepro-anniversary-button lepro-anniversary-button__primary flex relative" ${variantProduct.available == false ? 'disabled="true"' : '' }>
              <div class="le-loading__loading align-items-center justify-center flex absolute">
                <svg class="le_icon" viewBox="0 0 1024 1024" width="28" height="28"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_loading"></use></svg>
              </div>
              <span class="btn-label buy-now flex__1">
                ${variantProduct.available == false ? 'Sold Out' : 'Buy Now'}
              </span>
              <span class="icon">
                <span class="icon-cart_linear"></span>
              </span>
            </button>
          </le-add-cart-btn-anniversary>
        </div>
      </div>`

    })
    
    if (!is_more) {
      contentNode += '</div>'
    }
    
    const tabContent = this.querySelector('[data-tab-content]')
    if (tabContent) {
      tabContent.innerHTML = contentNode

      this.restartProductTime()
    }

    const dataMoreLink = this.querySelector('.le-product-more')
    if (dataMoreLink && products.length < limit) {
      dataMoreLink.style.display = 'none'
    } else {
      dataMoreLink.style.display = 'flex'
    }
  }

  // 倒计时内容
  renderDealTime(metafields) {
    let text = ''
    const discount = metafields?.variants_discounts_and_marketing?.product_detail_max_discount
    if (discount && discount.endAt) {
      text = `<div data-deal-time data-end-time="${discount.endAt}" class="deals-time align-center">Deal Ends In 00D 00H 00M 00S</div>`
    }
    return text
  }

  // 重写加载商品的倒计时
  restartProductTime() {
    const holidayMainNode = document.querySelector('le-holiday-main')
    if (holidayMainNode) {
      holidayMainNode.elements = holidayMainNode.getElements()
      holidayMainNode.setProductCountTme()
    }
  }
}
customElements.define('le-tab-anniversary', LeTabAnniversary);

// 加购按钮重写
class LeAddCartBtnAnniversary extends LeAddCartBtn {
  timer = null
  
  /** 重写点击的回调 */
  callbackClick(e) {
    this.setTipError(e, 'block')
    this.showTipError(e)
  }

  // 添加定时器隐藏错误提示
  showTipError(e) {
    if (!this.timer) {
      this.timer = setTimeout(() => {
        this.setTipError(e)

        clearTimeout(this.timer)
        this.timer = null
      }, 1000 * 5)
    }
  }
  // 显示/隐藏错误提示
  setTipError(e, display = 'none') {
    const selectProducts = this.dataset.products
    if (selectProducts) {
      const products = JSON.parse(selectProducts)
      if (products && products.length < 1) {
        const parentNode = e.target.closest('le-product-select')

        const tipError = parentNode.querySelector('[data-tip-error]')
        if (tipError) {
          tipError.style.display = display
        }
      }
    }
  }
}
customElements.define('le-add-cart-btn-anniversary', LeAddCartBtnAnniversary)